module.exports = __webpack_public_path__ + "img/n_logo2@2x.dff32e0d.png";